module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "dark": "",
      "light": "",
      "overflow": "",
      "absolute": ""
    },
    model: {
      value: (_vm.leftSidebar),
      callback: function($$v) {
        _vm.leftSidebar = $$v
      },
      expression: "leftSidebar"
    }
  }, [_c('v-list', _vm._l((_vm.menuItems), function(item, index) {
    return _c('v-list-group', {
      key: index,
      attrs: {
        "value": item.active
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "to": item.link
      },
      on: {
        "click": function($event) {}
      },
      slot: "item"
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), (_vm.hasSub(item)) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.hasSub(item)) ? _c('v-list', _vm._l((item.sub), function(sub, index) {
      return (_vm.isAllowed(sub.title)) ? _c('v-list-tile', {
        key: index,
        attrs: {
          "to": sub.link
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(sub.title))])], 1)], 1) : _vm._e()
    })) : _vm._e()], 1)
  })), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.isAuth) ? _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("                            \n                        Logout\n                    ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "fixed": "",
      "dense": ""
    }
  }, [_c('span', {
    staticClass: "hidden-md-and-up",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.leftSidebar = !_vm.leftSidebar
      }
    }
  }, [_c('v-toolbar-side-icon')], 1), _vm._v(" "), _c('v-toolbar-title', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.basePath + 'storage/img/logo.png',
      "width": "150px"
    }
  })])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isSearch) ? _c('v-text-field', {
    staticClass: "mb-0 pb-0 caption",
    attrs: {
      "name": "search",
      "label": "search",
      "id": "search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-sm-and-down"
  }, [(_vm.isAuth) ? _c('v-btn', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideSearch),
      expression: "hideSearch"
    }],
    staticClass: "mb-2 pb-0 caption",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleSearch($event)
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAuth) ? _c('v-btn', {
    staticClass: "mb-2 pb-0 caption",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleFilter()
      }
    }
  }, [(_vm.filteredList) ? _c('v-icon', {
    attrs: {
      "left": "",
      "large": "",
      "color": "red"
    }
  }, [_vm._v("filter_list")]) : _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("filter_list")]), _vm._v("\n                Filter\n            ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l((_vm.menuItems), function(item, index) {
    return _c('v-menu', {
      key: index,
      attrs: {
        "offset-y": "",
        "bottom": ""
      }
    }, [_c('v-btn', {
      staticClass: "caption",
      attrs: {
        "slot": "activator",
        "flat": "",
        "to": item.link
      },
      on: {
        "click": function($event) {}
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "dark": ""
      }
    }, [_vm._v(_vm._s(item.icon))]), _vm._v("\n                    " + _vm._s(item.title) + "\n                ")], 1), _vm._v(" "), (_vm.hasSub(item)) ? _c('v-list', _vm._l((item.sub), function(sub, index) {
      return (_vm.isAllowed(sub.title)) ? _c('v-list-tile', {
        key: index,
        attrs: {
          "to": sub.link
        }
      }, [_c('v-list-tile-title', {
        staticClass: "caption"
      }, [_vm._v("\n                            " + _vm._s(sub.title) + "\n                        ")])], 1) : _vm._e()
    })) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.isAuth) ? _c('v-btn', {
    staticClass: "caption mb-2 pb-0 hidden-sm-and-down",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("exit_to_app")]), _vm._v("\n                Logout\n            ")], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('filter-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d33e31a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Header.vue
// module id = 309
// module chunks = 0